/* jn-pdp-v2.js — 商品页：优惠券复制/应用反馈 + CHECK OUT NOW 直达结账 + 主图悬停放大镜
 * 0907 修复：见 1b / 1c 两段。
 * 轮播 / 缩略图 / 灯箱全部用主题自带的 media-gallery + zoom-dialog，这里不重写。
 * 全程 try/catch 兜底：这块挂了也不能影响加购。
 */
(function () {
  'use strict';

  /* ---------------- 1. 优惠券「Claim」→ 复制到剪贴板 ---------------- */

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // 老浏览器 / 非安全上下文兜底
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand failed'));
      } catch (err) {
        reject(err);
      }
    });
  }

  function initCoupons() {
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-jn-claim]') : null;
      if (!btn) return;

      event.preventDefault();
      var code = btn.getAttribute('data-jn-claim') || '';
      if (!code) return;

      var section = btn.closest('.jn-coupons');
      /* 0907 修复：提示优先写进被点的那张卡片里（snippets/jn-pdp-coupons.liquid 新增的
         [data-jn-coupon-card-status]），列表底部的 [data-jn-coupon-status] 只作兜底；
         4s 自动消失延长到 8s，别让客户还没看清就没了。 */
      var card = btn.closest('.jn-coupon');
      var status =
        (card && card.querySelector('[data-jn-coupon-card-status]')) ||
        (section ? section.querySelector('[data-jn-coupon-status]') : null);

      function settle(message) {
        btn.classList.add('is-claimed');
        if (status) status.textContent = message;
        window.clearTimeout(btn._jnTimer);
        btn._jnTimer = window.setTimeout(function () {
          btn.classList.remove('is-claimed');
          if (status && status.textContent === message) status.textContent = '';
        }, 8000);
      }

      copyText(code).then(
        function () {
          settle('Code ' + code + ' copied — paste it at checkout.');
        },
        function () {
          // 复制失败也要给反馈，把码留在屏幕上让用户自己抄
          settle('Your code is ' + code + ' — enter it at checkout.');
        }
      );
    });
  }

  /* ---------------- 1b. 0907 修复：Apply 回跳后的反馈 ----------------
   * 券卡的 Apply 链接现在跳 /discount/<code>?redirect=<本页>?applied=<code>。
   * 回到本页读到 ?applied= 后回读 /cart.js：discount_codes 里确有该码才显示
   * 「Applied ✓」（空车时 applicable 为 false 属正常，加购后自动转 true）；
   * 没有该码就明确报失败，绝不假称成功。最后用 replaceState 清掉参数，避免刷新重放。
   */

  function showToast(message) {
    try {
      var old = document.querySelector('.jn-toast');
      if (old) old.parentNode.removeChild(old);
      var el = document.createElement('div');
      el.className = 'jn-toast';
      el.setAttribute('role', 'status');
      el.textContent = message;
      document.body.appendChild(el);
      window.requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
      window.setTimeout(function () {
        el.classList.remove('is-visible');
        window.setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 400);
      }, 5000);
    } catch (err) {
      /* noop */
    }
  }

  function stripAppliedParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('applied');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* noop */
    }
  }

  function initAppliedFeedback() {
    var match = /[?&]applied=([^&#]+)/.exec(window.location.search);
    if (!match) return;
    var code = '';
    try {
      code = decodeURIComponent(match[1].replace(/\+/g, ' ')).trim();
    } catch (err) {
      code = match[1];
    }
    stripAppliedParam();
    if (!code) return;

    var btn = null;
    var claims = document.querySelectorAll('[data-jn-claim]');
    for (var i = 0; i < claims.length; i++) {
      if ((claims[i].getAttribute('data-jn-claim') || '').toLowerCase() === code.toLowerCase()) {
        btn = claims[i];
        break;
      }
    }
    var card = btn ? btn.closest('.jn-coupon') : null;
    var section = document.querySelector('.jn-coupons');
    var status =
      (card && card.querySelector('[data-jn-coupon-card-status]')) ||
      (section ? section.querySelector('[data-jn-coupon-status]') : null);

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        var hit = null;
        for (var j = 0; j < codes.length; j++) {
          if (String(codes[j].code || '').toLowerCase() === code.toLowerCase()) {
            hit = codes[j];
            break;
          }
        }
        if (hit) {
          if (card) card.classList.add('is-applied');
          if (status) status.textContent = 'Applied ✓ — shows in cart';
          showToast('Discount ' + code + ' applied — you’ll see it in your cart');
        } else {
          if (status) status.textContent = 'Could not apply ' + code + ' — enter it at checkout.';
          showToast('Could not apply ' + code + ' — enter it at checkout');
        }
      })
      .catch(function () {
        if (status) status.textContent = 'Could not confirm ' + code + ' — check your cart.';
      });
  }

  /* ---------------- 1c. 0907 修复：CHECK OUT NOW 直达结账 ----------------
   * blocks/accelerated-checkout.liquid 里那个 <button name="checkout"> 挂在
   * action=/cart/add 的商品表单里，name=checkout 对 /cart/add 无效，
   * 点了只会被 product-form 当普通加购处理（弹抽屉、不去结账）。
   * 这里在捕获阶段拦截点击：用表单数据 POST /cart/add.js，成功后跳 /checkout
   * （购物车级券码在 Shopify 的 discount_code cookie 里，结账页会自动带上；
   * 本店 Copy code 不写任何本地存储，所以没有「存储里的码」需要额外挂）。
   * 失败则退回主题原生加购流程（会显示主题自己的错误提示），不静默。
   */

  function initCheckoutNow() {
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest ? event.target.closest('.jn-checkout-now') : null;
        if (!btn || btn.disabled) return;
        var form = btn.form || btn.closest('form');
        if (!form || !window.fetch || !window.FormData) return;

        event.preventDefault();
        event.stopPropagation();
        if (btn._jnBusy) return;
        btn._jnBusy = true;
        btn.classList.add('is-busy');
        btn.setAttribute('aria-busy', 'true');

        var fd = new FormData(form);
        fd.delete('sections');
        fd.delete('sections_url');

        function fallback() {
          btn._jnBusy = false;
          btn.classList.remove('is-busy');
          btn.removeAttribute('aria-busy');
          try {
            if (form.requestSubmit) form.requestSubmit();
            else form.submit();
          } catch (err) {
            /* noop */
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (r) {
            return r.json().then(function (json) {
              return { ok: r.ok, json: json };
            });
          })
          .then(function (res) {
            if (!res.ok || (res.json && res.json.status)) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(fallback);
      },
      true
    );
  }

  /* ---------------- 2. 主图悬停放大镜 ---------------- */

  var ZOOM = 2.4;

  function bigSrc(img) {
    var url = img.getAttribute('data-max-resolution') || img.currentSrc || img.src || '';
    if (!url) return '';
    // 3840 太重，换成 1600 —— srcset 里就有这一档，通常已经在缓存里
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=1600');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
  }

  function attachLens(host) {
    if (host._jnLensReady) return;
    var img = host.querySelector('img.product-media__image');
    if (!img) return;

    host._jnLensReady = true;
    host.classList.add('jn-lens-host');

    var lens = document.createElement('div');
    lens.className = 'jn-lens';
    lens.setAttribute('aria-hidden', 'true');
    host.appendChild(lens);

    var hint = document.createElement('span');
    hint.className = 'jn-lens-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Hover to zoom';
    host.appendChild(hint);

    var geo = null;

    function measure() {
      var hostRect = host.getBoundingClientRect();
      var imgRect = img.getBoundingClientRect();
      if (!imgRect.width || !imgRect.height) return null;
      return {
        left: imgRect.left - hostRect.left,
        top: imgRect.top - hostRect.top,
        w: imgRect.width,
        h: imgRect.height,
        pageLeft: imgRect.left,
        pageTop: imgRect.top,
      };
    }

    function enter() {
      geo = measure();
      if (!geo) return;
      var src = bigSrc(img);
      if (!src) return;
      lens.style.left = geo.left + 'px';
      lens.style.top = geo.top + 'px';
      lens.style.width = geo.w + 'px';
      lens.style.height = geo.h + 'px';
      lens.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      lens.style.backgroundSize = geo.w * ZOOM + 'px ' + geo.h * ZOOM + 'px';
    }

    function move(event) {
      if (!geo) {
        enter();
        if (!geo) return;
      }
      var x = event.clientX - geo.pageLeft;
      var y = event.clientY - geo.pageTop;
      if (x < 0 || y < 0 || x > geo.w || y > geo.h) {
        lens.classList.remove('is-active');
        return;
      }
      var px = (x / geo.w) * 100;
      var py = (y / geo.h) * 100;
      // 背景放大 ZOOM 倍后，用百分比定位刚好把光标处对齐到镜片同一相对位置
      lens.style.backgroundPosition = px + '% ' + py + '%';
      lens.classList.add('is-active');
    }

    function leave() {
      geo = null;
      lens.classList.remove('is-active');
    }

    host.addEventListener('mouseenter', enter);
    host.addEventListener('mousemove', move);
    host.addEventListener('mouseleave', leave);
    window.addEventListener(
      'resize',
      function () {
        geo = null;
        lens.classList.remove('is-active');
      },
      { passive: true }
    );
  }

  function initLens() {
    // 触摸设备不做放大镜，交给主题的点击灯箱
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var scope = document.querySelector('.product-information__media');
    if (!scope) return;

    function scan() {
      var hosts = scope.querySelectorAll('.product-media-container--image, .product-media-container--zoomable');
      Array.prototype.forEach.call(hosts, function (host) {
        // 灯箱里那份不挂，它自己有 drag-zoom
        if (host.closest('.dialog-zoomed-gallery')) return;
        try {
          attachLens(host);
        } catch (err) {
          /* 单张图失败不影响其它 */
        }
      });
    }

    scan();

    // 换变体会重渲染图库，重新扫一遍
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        window.clearTimeout(scope._jnScanTimer);
        scope._jnScanTimer = window.setTimeout(scan, 120);
      });
      mo.observe(scope, { childList: true, subtree: true });
    }
  }

  function boot() {
    try {
      initCoupons();
    } catch (err) {
      /* noop */
    }
    /* 0907 修复：Apply 回跳反馈 + CHECK OUT NOW 直达结账 */
    try {
      initAppliedFeedback();
    } catch (err) {
      /* noop */
    }
    try {
      initCheckoutNow();
    } catch (err) {
      /* noop */
    }
    try {
      initLens();
    } catch (err) {
      /* noop */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
